import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { FormattedRelyingPartyConfig, RelyingPartyConfig } from "@idw-types/data/relying-party-config";

export const formatRelyingPartyConfigs = (
    relyingPartyConfigs: Array<RelyingPartyConfig>,
    companies: Array<AxnCompany>
): Array<FormattedRelyingPartyConfig> => {
    return relyingPartyConfigs.map(rp => formatRelyingPartyConfig(rp, companies));
};

export const formatRelyingPartyConfig = (
    relyingPartyConfig: RelyingPartyConfig,
    companies: Array<AxnCompany>
): FormattedRelyingPartyConfig => {
    const company = companies.find(c => c.id === relyingPartyConfig.companyID);
    return {
        company: company,
        contractCode: relyingPartyConfig.contractCode,
        customAXNHostName: relyingPartyConfig.customAXNHostName,
        customDCUIHostName: relyingPartyConfig.customDCUIHostName,
        id: relyingPartyConfig.id,
        name: relyingPartyConfig.name,
        whiteLabelAXNUI3HostName: relyingPartyConfig.whiteLabelAXNUI3HostName,
        whiteLabelAXNUIHostName: relyingPartyConfig.whiteLabelAXNUIHostName,
        whiteLabelDCUIHostName: relyingPartyConfig.whiteLabelDCUIHostName,
        whiteLabelKBAHostName: relyingPartyConfig.whiteLabelKBAHostName,
        whiteLabelKBA2HostName: relyingPartyConfig.whiteLabelKBA2HostName,
        permissions: relyingPartyConfig.permissions,
        status: relyingPartyConfig.status
    };
};